module.exports = __webpack_public_path__ + "static/debtMobileBox-c001b36486a9bddff02d128968cc962f.png";